// source: imports/content/interaction_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

goog.exportSymbol(
    'proto.com.chegg.rio.content.interaction.InteractionType', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.content.interaction.InteractionType = {
  UNKNOWN_INTERACTIONTYPE: 0,
  CLICK: 1,
  SELECT: 2,
  OPEN: 3,
  EXPAND: 4,
  START: 5,
  CROP: 6,
  CAPTURE: 7,
  TAP: 8,
  SEARCH: 9,
  CONFIRM: 10,
  COLLAPSE: 11,
  TYPED: 12,
  ACCEPT: 13,
  UPLOAD: 14,
  DISMISS: 15,
  HOVER: 16,
  STOP: 17,
  SUBMIT: 18,
  READ: 19,
  REJECT: 20,
  CLOSE: 21,
  SAVE: 22,
  CANCEL: 23,
  SCROLL: 24,
  SPAM: 25,
  DRAG: 26,
  SUBSCRIBE: 27,
  SWIPE: 28,
  UNSUBSCRIBE: 29
};

goog.object.extend(exports, proto.com.chegg.rio.content.interaction);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/content/interaction_type_pb.js
// module id = 77
// module chunks = 11